import ApplicationController from './application_controller'
import $ from 'jquery'

export default class extends ApplicationController

  # Passing static data to dashboards
  initialize: ->
    $dashboard = $(@element)
    $(window).on 'message', (event) ->
      if event.originalEvent.origin is window.location.origin and
         event.originalEvent.data['id'] in ['teacher_dashboard', 'class_dashboard', 'student_dashboard'] and
         event.originalEvent.data['command'] is 'ready'
        console.log '[Dashboard Controller] Received message from dashboard ', event.originalEvent.data
        parameters = Object.camelizeEntries $dashboard.data('dashboard')
        console.log '[Dashboard Controller] Sending static parameters to dashboard ', parameters
        $dashboard.prop('contentWindow').postMessage parameters, window.location.origin
